import { FontSizes, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  tagsContent: {
    margin: '0px -20px',
    padding: 20,
  },
  emptyTagsView: {
    padding: 20,
    width: '1100px',
    fontSize: FontSizes.size16,
    borderWidth: 1,
    borderColor: theme.palette.neutralLight,
    borderStyle: 'solid',
    textAlign: 'center',
  },
  closeButton: {
    color: theme.palette.neutralDark,
  },
  commandBarButton: {
    height: 40,
  },
  customWidth: {
    width: '1100px',
  },
}));
